import React, {Component} from 'react'
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl'

class IntervalLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            intervalType: this.props.intervalType,
            intervalLabel: this.props.intervalLabel,
            dayOfMonthLabel: this.props.dayOfMonthLabel,
            dayOfWeekLabel: this.props.dayOfWeekLabel,
            monthLabel: this.props.monthLabel,
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            intervalType: nextProps.intervalType,
            intervalLabel: nextProps.intervalLabel,
            dayOfMonthLabel: nextProps.dayOfMonthLabel,
            dayOfWeekLabel: nextProps.dayOfWeekLabel,
            monthLabel: nextProps.monthLabel,
        })
    }

    format(txt) {
        return <div className={'w-100 d-flex justify-content-start'}>
            {txt}
        </div>
    }

    render() {
        switch (this.state.intervalType) {
            case 'daily':
                return <FormattedMessage
                    id="invoice.recurring.daily_label"
                    defaultMessage="Every {interval} day(s)"
                    values={{
                        interval: this.state.intervalLabel
                    }} />
            case 'weekly':
                return <FormattedMessage
                    id="invoice.recurring.weekly_label"
                    defaultMessage="Every {interval} week(s) on {dayOfWeek}"
                    values={{
                        interval: this.state.intervalLabel,
                        dayOfWeek: this.state.dayOfWeekLabel,
                    }} />
            case 'monthly':
                return <FormattedMessage
                    id="invoice.recurring.monthly_label"
                    defaultMessage="On the {dayOfMonth} of every {interval} month(s)"
                    values={{
                        interval: this.state.intervalLabel,
                        dayOfMonth: this.state.dayOfMonthLabel,
                    }} />
            case 'yearly':
                return <FormattedMessage
                    id="invoice.recurring.yearly_label"
                    defaultMessage="Every {interval} year(s) on the {dayOfMonth} of {month}"
                    values={{
                        interval: this.state.intervalLabel,
                        dayOfMonth: this.state.dayOfMonthLabel,
                        month: this.state.monthLabel,
                    }}/>
        }
        return <span />
    }


}

export default IntervalLabel





// WEBPACK FOOTER //
// ./src/invoice/recurring/intervallabel.component.jsx